const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS5Logo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.285,
    height: 87.596,
    viewBox: "0 0 55.902 23.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m49.816 0-.008.092c-.151 1.78-.295 3.56-.43 5.34l-.01.107h.936l.03-.031c.275-.295.598-.508.972-.643a3.456 3.456 0 0 1 1.162-.205c.397 0 .746.064 1.051.186.307.122.561.29.767.51.214.22.375.477.485.777.11.3.166.63.166.988 0 .347-.053.687-.159 1.02a2.53 2.53 0 0 1-.468.884 2.393 2.393 0 0 1-.817.623c-.321.158-.707.238-1.16.238-.272 0-.53-.033-.775-.101a2.362 2.362 0 0 1-.654-.318 1.882 1.882 0 0 1-.49-.553 2.37 2.37 0 0 1-.284-.807l-.015-.084h-1.047l.014.114c.058.436.18.829.364 1.172l.003.002c.19.334.427.618.71.85h.003c.29.225.62.395.986.513.368.118.762.178 1.186.178.59 0 1.11-.094 1.558-.285h.002a3.163 3.163 0 0 0 1.113-.8 3.25 3.25 0 0 0 .67-1.2v-.002c.15-.456.225-.948.225-1.473 0-.47-.082-.913-.246-1.326a3.287 3.287 0 0 0-.68-1.072 3.048 3.048 0 0 0-1.025-.73 3.094 3.094 0 0 0-1.283-.267c-.195 0-.397.01-.61.03-.215.02-.428.055-.636.107-.213.046-.42.12-.614.217-.122.06-.223.15-.33.23L50.8.963h4.596V0Z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "23.2816px",
      lineHeight: 1.15,
      fontFamily: "Avenir",
      InkscapeFontSpecification: "Avenir",
      letterSpacing: 0,
      opacity: 0.635484,
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59.538V17.741h1.445V.538ZM9.97 3.62a1.06 1.06 0 0 0-1.063 1.065c0 .59.473 1.062 1.062 1.062.611 0 1.064-.474 1.064-1.062A1.05 1.05 0 0 0 9.97 3.619zM4.086 6.922c-1.005 0-1.915.292-2.575.82A2.788 2.788 0 0 0 .444 9.977c0 .663.138 1.257.62 1.75.482.494 1.3.886 2.651 1.17h.002c.77.158 1.508.31 2.049.59.54.278.88.672.88 1.336 0 .562-.278 1.03-.714 1.36-.435.33-1.027.52-1.64.52-1.275 0-2.482-.673-2.994-1.697l-.023-.044L0 15.827l.02.037c.8 1.396 2.312 2.15 4.226 2.15 1.117 0 2.079-.315 2.762-.883.683-.568 1.085-1.39 1.085-2.399 0-.948-.278-1.616-.882-2.1-.605-.483-1.528-.784-2.822-1.022-.677-.124-1.307-.273-1.763-.534-.455-.26-.735-.626-.735-1.212 0-.492.277-.897.693-1.182a2.722 2.722 0 0 1 1.503-.448c1.164 0 1.89.483 2.406 1.447l.023.042 1.298-.77-.02-.038c-.71-1.373-2.044-1.993-3.707-1.993Zm13.734 0c-2.989 0-5.635 2.396-5.635 5.41 0 3.013 2.579 5.41 5.635 5.41 1.805 0 3.16-.791 3.964-2.026v1.507c0 1.543-.372 2.703-1.075 3.476-.704.773-1.742 1.166-3.092 1.166-1.618 0-3.143-.628-4.085-1.951l-.028-.042-1.132 1.058.025.031c1.144 1.487 3.262 2.215 5.197 2.215 1.764 0 3.175-.53 4.144-1.573.969-1.044 1.492-2.595 1.492-4.629v-9.78h-1.446v1.754c-.803-1.234-2.16-2.026-3.964-2.026Zm11.86 0c-1.542 0-2.967.816-3.594 2.106h-.01a6.105 6.105 0 0 1-.06-.773c-.01-.345-.017-.723-.028-1.019l-.002-.042h-1.445v.044c0 .05.008.232.019.489l.038.91c.029.657.057 1.325.057 1.43v7.674h1.446v-5.227c0-1.351.355-2.421.978-3.153.623-.732 1.514-1.127 2.602-1.127.873 0 1.512.265 1.939.813.427.55.642 1.39.642 2.538v6.156h1.446v-6.225c0-1.568-.334-2.717-1.009-3.475-.675-.759-1.686-1.119-3.018-1.119Zm9.753 0c-1.392 0-3.006.522-4.014 1.484l-.03.029.848.993.032-.029a4.718 4.718 0 0 1 3.164-1.165c.9 0 1.624.208 2.123.624.499.415.775 1.039.775 1.89v.566h-1.63c-1.794 0-3.226.284-4.216.87-.99.587-1.533 1.482-1.533 2.684 0 .962.374 1.752 1.032 2.297.658.546 1.597.848 2.726.848 1.71 0 2.85-.62 3.648-1.956.003.668.046 1.186.134 1.648l.006.036h1.355l-.007-.05c-.136-.924-.203-2.214-.203-3.933v-3.101c0-1.164-.354-2.1-1.06-2.743-.707-.643-1.761-.992-3.15-.992Zm-30.189.272v10.547h1.448V7.194Zm8.463 1.04a4.104 4.104 0 0 1 4.121 4.098c0 2.24-1.835 4.098-4.098 4.098-2.33 0-4.098-1.903-4.098-4.098 0-2.24 1.836-4.098 4.075-4.098zm23.04 4.255h1.584v.682c0 1.09-.297 1.97-.89 2.58-.593.61-1.484.951-2.687.951-.67 0-1.26-.195-1.681-.53a1.717 1.717 0 0 1-.674-1.373c0-.83.504-1.402 1.304-1.774.8-.372 1.893-.536 3.043-.536z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "Avenir",
      InkscapeFontSpecification: "Avenir",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "-1.85207px",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#000",
      fillOpacity: 0.635294,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0882052,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS5Logo);
export default __webpack_public_path__ + "static/media/s5_logo.48b41afde38662364eba4141ea441fdc.svg";
export { ForwardRef as ReactComponent };